module.exports = __webpack_public_path__ + "static/media/ils_loan_intro_card.e1ed6dd1.svg";